import { Button, Icon, Box, Text } from '@deseretbook/react-ui'
import { Link } from 'react-router-dom'
import React from 'react'

import './BreadcrumbButton.css'

/**
 * Breadcrumb link button that'll link to the most recent major page. (library, discover)
 *
 * @returns {function} Component
 */
const BreadcrumbButton = ({ colorStyle = 'white' }) => {
  const linkLocation = localStorage.getItem('breadcrumb') || 'library'
  return (
    <Box id="BreadcrumbButtonContainer">
      <Button
        as={Link}
        to={linkLocation === 'discover' ? '/' : '/library'}
        className={`breadcrumb-button breadcrumb-button-${colorStyle}`}
      >
        <Box alignItems="center" style={{ color: 'inherit' }}>
          <Icon
            className={`breadcrumb-button-icon breadcrumb-button-icon-${colorStyle}`}
            name={linkLocation === 'discover' ? 'compass' : 'library'}
            style={{ height: '24px', width: '24px' }}
            svgProps={{
              style: {
                height: '24px',
                width: '24px',
              },
            }}
          />
          <Text
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 700,
              fontSize: '14px',
              color: 'inherit',
            }}
          >
            {linkLocation === 'discover' ? 'Discover' : 'Library'}
          </Text>
        </Box>
      </Button>
    </Box>
  )
}

export default BreadcrumbButton
